import { Box, InputLabel, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import { TOTAL_INCOME_STRUCTURE_ID } from 'src/Enum/IncomeStructure';
import { useIncomeStructure } from '../IncomeStructureProvider/IncomeStructureProvider';
import { findMasterDataById } from '../utils';
import OtherIncomeYearFieldsForm from './OtherIncomeYearFieldsForm';

const OtherIncomeTotalForm = () => {
  const { otherIncome } = useIncomeStructure();

  const totalOtherIncome = findMasterDataById(
    otherIncome,
    TOTAL_INCOME_STRUCTURE_ID.TOTAL_OTHER_INCOME
  );

  return (
    <>
      {totalOtherIncome && (
        <Flex width={1} mt={2} alignItems={'center'}>
          <Box width={1} minWidth={235} maxWidth={350}>
            <InputLabel sx={{ textAlign: 'right', fontWeight: 800 }} required>
              {totalOtherIncome.nameTh}
            </InputLabel>
            <Typography textAlign={'right'} color={'text.secondary'}>
              (พันบาท)
            </Typography>
          </Box>
          <OtherIncomeYearFieldsForm keyItem={totalOtherIncome.id.toString()} />
        </Flex>
      )}
    </>
  );
};

export default OtherIncomeTotalForm;
